import type { DefaultOptions } from '@apollo/client/core';

// Apollo aplica también a client.query el errorPolicy de watchQuery: con 'all', un error GraphQL
// no rechaza la consulta y llega en result.errors.
export const apolloDefaultOptions: DefaultOptions = {
  watchQuery: {
    errorPolicy: 'all',
  },
};
